import { c as _c } from "react/compiler-runtime";
import { HeaderTitle, NavigationHeader } from '@onefootprint/idv2';
import { Button } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useHandoffMachine from '../../hooks/use-handoff-machine';
const Expired = () => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.expired"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const [state] = useHandoffMachine();
  const {
    opener
  } = state.context;
  const handleClick = _temp;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NavigationHeader />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp2);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== opener || $[5] !== t) {
    t3 = opener === "mobile" ? t(_temp3) : t(_temp4);
    $[4] = opener;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <HeaderTitle title={t2} subtitle={t3} />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== opener || $[11] !== t) {
    t5 = opener === "mobile" && <Button onClick={handleClick} fullWidth={true}>{t(_temp5)}</Button>;
    $[10] = opener;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex flex-col items-center justify-center h-full text-center"><div>{t1}<form className="grid gap-8">{t4}{t5}</form></div></div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default Expired;
function _temp() {
  window.close();
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.subtitle.mobile;
}
function _temp4($_1) {
  return $_1.subtitle.desktop;
}
function _temp5($_2) {
  return $_2.cta;
}